(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_8b56e4d"] && !Shopify.designMode) return;
  try {
    /* ======================================================
   CSS.escape polyfill (Safari-safe)
====================================================== */
if (!window.CSS) window.CSS = {};
if (typeof window.CSS.escape !== 'function') {
  window.CSS.escape = function (value) {
    return String(value).replace(/[^a-zA-Z0-9_-]/g, function (ch) {
      const hex = ch.charCodeAt(0).toString(16);
      return '\\' + hex + ' ';
    });
  };
}

(function(){
  console.log('HEADER SCRIPT LOADED');
  const headerRoot = document.querySelector('[data-ai-header]');
  if (!headerRoot) return;
  const aiGenId = headerRoot.dataset.aiGenId;

  /* ======================================================
     Small utility: debounce
  ====================================================== */
  function debounce(fn, wait){
    let t;
    return function(...args){
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  class HeaderBlock extends HTMLElement {
    /* ======================================================
       Lifecycle
    ====================================================== */
    connectedCallback(){
      this.activeInput = null;
      this._lastFocus = null;

      this._predictiveAbort = null;
      this._predictiveCache = new Map();

      this._priceCache = new Map();
      this._priceToken = 0;

      /* Header / search refs */
      this.searchIconMobile = this.querySelector('.ai-header-search-icon-mobile-' + aiGenId);
      this.searchDesktopInput = this.querySelector('.ai-header-search-input-' + aiGenId);


      this.searchMobileContainer = this.querySelector('.ai-header-search-mobile-' + aiGenId);
      this.searchMobileInput = this.querySelector('.ai-header-search-mobile-input-' + aiGenId);
      this.searchClearBtn = this.searchMobileContainer
        ? this.searchMobileContainer.querySelector('.ai-header-search-clear-' + aiGenId)
        : null;
      /* Drawer refs */
    
      this.hamburger = this.querySelector('.ai-header-hamburger-' + aiGenId);
      this.mobileMenu = this.querySelector('.ai-header-mobile-menu-' + aiGenId);
      this.mobileMenuClose = this.querySelector('.ai-header-mobile-menu-close-' + aiGenId);
      this.mobileMenuOverlay = this.querySelector('.ai-header-mobile-menu-overlay-' + aiGenId);

      /* Init */
      this.bindHeaderHeightSync();
      this.ensureMobileSearchInBody();
      this.ensureMobileDrawerInBody();
      this.ensurePredictiveDropdown();

      this.setupEventListeners();
      this.setupPredictiveSearch();
      this.setupMobileDrawerAccordions();
      this.setupMobileClearButton();
    }

    /* ======================================================
       DOM placement helpers
    ====================================================== */
    ensureMobileSearchInBody(){
      if (!this.searchMobileContainer) return;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (!isMobile) return;
      if (this.searchMobileContainer.dataset.movedToBody === 'true') return;

      document.body.appendChild(this.searchMobileContainer);
      this.searchMobileContainer.dataset.movedToBody = 'true';
    }

    ensureMobileDrawerInBody(){
      if (!this.mobileMenu || !this.mobileMenuOverlay) return;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (!isMobile) return;
      if (this.mobileMenu.dataset.movedToBody === 'true') return;

      document.body.appendChild(this.mobileMenu);
      document.body.appendChild(this.mobileMenuOverlay);
      this.mobileMenu.dataset.movedToBody = 'true';
    }

    ensurePredictiveDropdown(){
  const existing = document.querySelector('.ai-predictive-' + aiGenId);
  const existingBackdrop = document.querySelector('.ai-predictive-backdrop-' + aiGenId);

  if (existing){
    this.predictiveEl = existing;
    this.predictiveBackdrop = existingBackdrop;
    return;
  }

  const backdrop = document.createElement('div');
  backdrop.className = 'ai-predictive-backdrop-' + aiGenId;
  document.body.appendChild(backdrop);
  this.predictiveBackdrop = backdrop;

  const el = document.createElement('div');
  el.className = 'ai-predictive-' + aiGenId;
  el.setAttribute('role', 'listbox');
  el.setAttribute('aria-label', 'Search suggestions');

  el.innerHTML = `
    <div class="ai-predictive__inner-${aiGenId}"></div>
    <div class="ai-predictive__footer-${aiGenId}">
      <a class="ai-predictive__all-${aiGenId}" href="/search">View all results</a>
    </div>
  `;

  document.body.appendChild(el);
  this.predictiveEl = el;

  backdrop.addEventListener('click', () => {
    this.closePredictive();
    this.closeMobileSearch();
  });

  this.predictiveEl.addEventListener('click', (e) => {
  if (e.target.closest('[data-ai-predictive-add]')) return;
});
}

    /* ======================================================
       Header height sync

    /* ======================================================
       Header height sync
    ====================================================== */
    bindHeaderHeightSync(){
      const setVar = () => {
        const h = Math.max(56, Math.round(this.getBoundingClientRect().height || 0));
        document.documentElement.style.setProperty('--site-header-height', h + 'px');
      };

      setVar();

      if ('ResizeObserver' in window){
        this.__ro = new ResizeObserver(() => setVar());
        this.__ro.observe(this);
      }

      let raf = null;
      const onScroll = () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = null;
          setVar();
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', setVar);
      window.addEventListener('orientationchange', setVar);
    }

    /* ======================================================
       Event binding
    ====================================================== */
    setupEventListeners(){
  /* Mobile search icon */
  if (this.searchIconMobile){
    this.searchIconMobile.addEventListener('click', () => {
      const isOpen = this.searchMobileContainer && this.searchMobileContainer.classList.contains('active');

      if (isOpen && this.searchMobileInput && (this.searchMobileInput.value || '').length){
        this.searchMobileInput.value = '';
        this.searchMobileInput.focus();
        if (this.searchClearBtn) this.searchClearBtn.hidden = true;
        this.closePredictive();
        return;
      }

      this.toggleMobileSearch();
    });
  }

  const cartTrigger = this.querySelector('[data-open-cart-drawer]');
if (cartTrigger) {
  cartTrigger.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();

    document.querySelectorAll('[class*="ai-predictive-"]').forEach((el) => {
      el.classList.remove('is-open');
      el.style.display = '';
    });

    document.querySelectorAll('[class*="ai-header-search-mobile-"]').forEach((el) => {
      el.classList.remove('active');
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('inert', '');
    });

    document.body.style.overflow = '';

    if (window.reCartDrawer) {
      await window.reCartDrawer.refresh(true);
    }
  });
}

  /* Drawer open */
if (this.hamburger){
  this.hamburger.addEventListener('click', (e) => {
    e.stopPropagation();

    const isDesktop = window.innerWidth >= 750;

if (isDesktop) {
  document.body.classList.toggle('desktop-nav-forced-open');

  if (document.body.classList.contains('desktop-nav-forced-open')) {
    this.hamburger.classList.add('is-open');
  } else {
    this.hamburger.classList.remove('is-open');
  }

  return;
}

    /* MOBILE: open drawer */
    if (this.mobileMenu && this.mobileMenu.classList.contains('active')) {
      this.closeMobileMenu();
    } else {
      this.openMobileMenu();
    }
  });
}

/* Drawer close */
if (this.mobileMenuClose){
  this.mobileMenuClose.addEventListener('click', () => this.closeMobileMenu());
}

if (this.mobileMenuOverlay){
  this.mobileMenuOverlay.addEventListener('click', () => this.closeMobileMenu());
}

/* Click outside drawer */
document.addEventListener('click', (e) => {
  if (!this.mobileMenu || !this.hamburger) return;
  if (!this.mobileMenu.classList.contains('active')) return;

  if (!this.mobileMenu.contains(e.target) && !this.hamburger.contains(e.target)) {
    this.closeMobileMenu();
  }
});

/* Click outside search / dropdown */
document.addEventListener('click', (e) => {
  const t = e.target;

  const clickedInsideDropdown =
    this.predictiveEl && this.predictiveEl.contains(t);

  const clickedInsideDesktopInput =
    this.searchDesktopInput && this.searchDesktopInput.contains(t);

  const clickedInsideMobileSearch =
    this.searchMobileContainer && this.searchMobileContainer.contains(t);

  const clickedSearchIcon =
    this.searchIconMobile && this.searchIconMobile.contains(t);

  const clickedInsideSearch =
    clickedInsideDropdown ||
    clickedInsideDesktopInput ||
    clickedInsideMobileSearch ||
    clickedSearchIcon;

  if (!clickedInsideSearch) {
    this.closePredictive();
    this.closeMobileSearch();
  }
});

/* Escape key */
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape'){
    this.closeMobileSearch();
    this.closeMobileMenu();
    this.closePredictive();
  }
});

/* Reposition predictive dropdown on viewport changes */
window.addEventListener('scroll', () => {
  if (this.predictiveEl && this.predictiveEl.classList.contains('is-open')){
    this.positionPredictive();
  }
}, { passive: true });

window.addEventListener('resize', () => {
  if (this.predictiveEl && this.predictiveEl.classList.contains('is-open')){
    this.positionPredictive();
  }
});

this.predictiveEl.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-ai-predictive-add]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  if (btn.dataset.aiPredictiveAdd === 'false') {
    const url = btn.dataset.productUrl;
    if (url) window.location.href = url;
    return;
  }

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  btn.innerHTML = '<span>Adding...</span>';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    if (!response.ok) throw new Error('Add failed');

    this.closePredictive();

    if (window.reCartDrawer) {
      await window.reCartDrawer.refresh(true);
    }
  } catch (err) {
    btn.disabled = false;
    btn.innerHTML = '<span>Try again</span>';
  }
});
}
    /* ======================================================
       Mobile clear button
    ====================================================== */
    setupMobileClearButton(){
      if (!this.searchClearBtn || !this.searchMobileInput) return;

      const sync = () => {
        const hasValue = (this.searchMobileInput.value || '').length > 0;
        this.searchClearBtn.hidden = !hasValue;
      };

      this.searchMobileInput.addEventListener('input', sync);
      this.searchMobileInput.addEventListener('focus', sync);

      this.searchClearBtn.addEventListener('click', () => {
        this.searchMobileInput.value = '';
        this.searchMobileInput.focus();
        sync();
        this.closePredictive();
      });

      sync();
    }

    /* ======================================================
       Mobile drawer accordions
    ====================================================== */
    setupMobileDrawerAccordions(){
      if (!this.mobileMenu) return;

      this.mobileMenu.addEventListener('click', (e) => {
        const topBtn = e.target.closest('.ai-drawer-btn-' + aiGenId);
        if (topBtn){
          const item = topBtn.closest('.ai-drawer-item-' + aiGenId);
          const sub = item ? item.querySelector('.ai-drawer-sub-' + aiGenId) : null;
          if (!sub) return;

          const isOpen = topBtn.getAttribute('aria-expanded') === 'true';

          this.mobileMenu.querySelectorAll('.ai-drawer-btn-' + aiGenId).forEach((b) => {
            if (b !== topBtn) b.setAttribute('aria-expanded', 'false');
          });

          this.mobileMenu.querySelectorAll('.ai-drawer-sub-' + aiGenId).forEach((ul) => {
            if (ul !== sub) ul.hidden = true;
          });

          if (!isOpen){
            sub.querySelectorAll('.ai-drawer-subbtn-' + aiGenId).forEach((b) => b.setAttribute('aria-expanded', 'false'));
            sub.querySelectorAll('.ai-drawer-subsub-' + aiGenId).forEach((ul) => ul.hidden = true);
          }

          topBtn.setAttribute('aria-expanded', String(!isOpen));
          sub.hidden = isOpen;
          return;
        }

        const subBtn = e.target.closest('.ai-drawer-subbtn-' + aiGenId);
        if (subBtn){
          const subItem = subBtn.closest('.ai-drawer-subitem-' + aiGenId);
          const subSub = subItem ? subItem.querySelector('.ai-drawer-subsub-' + aiGenId) : null;
          if (!subSub) return;

          const isOpen2 = subBtn.getAttribute('aria-expanded') === 'true';
          const parentUl = subBtn.closest('.ai-drawer-sub-' + aiGenId);

          if (parentUl){
            parentUl.querySelectorAll('.ai-drawer-subbtn-' + aiGenId).forEach((b) => {
              if (b !== subBtn) b.setAttribute('aria-expanded', 'false');
            });

            parentUl.querySelectorAll('.ai-drawer-subsub-' + aiGenId).forEach((ul) => {
              if (ul !== subSub) ul.hidden = true;
            });
          }

          subBtn.setAttribute('aria-expanded', String(!isOpen2));
          subSub.hidden = isOpen2;
        }
      });
    }

    /* ======================================================
       Mobile search open / close
    ====================================================== */
    toggleMobileSearch(){
      if (!this.searchMobileContainer) return;
      const isActive = this.searchMobileContainer.classList.contains('active');
      if (isActive) this.closeMobileSearch();
      else this.openMobileSearch();
    }

    openMobileSearch(){
      if (!this.searchMobileContainer) return;

      this.closeMobileMenu();

      this.searchMobileContainer.classList.add('active');
      this.searchMobileContainer.setAttribute('aria-hidden', 'false');
      this.searchMobileContainer.removeAttribute('inert');

      if (this.searchIconMobile){
        this.searchIconMobile.setAttribute('aria-expanded', 'true');
      }

      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        if (this.searchMobileInput) this.searchMobileInput.focus();
      }, 60);
    }

    closeMobileSearch(){
      if (!this.searchMobileContainer) return;

      this.searchMobileContainer.classList.remove('active');
      this.searchMobileContainer.setAttribute('aria-hidden', 'true');
      this.searchMobileContainer.setAttribute('inert', '');

      if (this.searchIconMobile){
        this.searchIconMobile.setAttribute('aria-expanded', 'false');
      }

      document.body.style.overflow = '';
      this.closePredictive();
    }

    /* ======================================================
       Mobile menu open / close
    ====================================================== */
    openMobileMenu(){
      if (!this.mobileMenu || !this.mobileMenuOverlay) return;
      if (this.hamburger) this.hamburger.classList.add('is-open');

      this.closeMobileSearch();
      this._lastFocus = document.activeElement;

      this.mobileMenu.classList.add('active');
      this.mobileMenuOverlay.classList.add('active');

      document.documentElement.classList.add('ai-drawer-open');
      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        const first = this.mobileMenu.querySelector('button, a, input, [tabindex]:not([tabindex="-1"])');
        if (first) first.focus();
      }, 50);
    }

    closeMobileMenu(){
      if (!this.mobileMenu || !this.mobileMenuOverlay) return;
      if (this.hamburger) this.hamburger.classList.remove('is-open');

      this.mobileMenu.classList.remove('active');
      this.mobileMenuOverlay.classList.remove('active');

      document.documentElement.classList.remove('ai-drawer-open');
      document.body.style.overflow = '';

      if (this._lastFocus && typeof this._lastFocus.focus === 'function'){
        this._lastFocus.focus();
      }

      this._lastFocus = null;
    }

    /* ======================================================
       Predictive search setup
    ====================================================== */
    setupPredictiveSearch(){
      const inputs = [this.searchDesktopInput, this.searchMobileInput].filter(Boolean);

      const handler = debounce(async (input) => {
        const q = (input.value || '').trim();

        if (q.length < 2){
          this.closePredictive();
          return;
        }

        this.activeInput = input;
        await this.fetchAndRenderPredictive(q);
      }, 160);

      inputs.forEach((input) => {
        input.addEventListener('input', () => handler(input));

        input.addEventListener('focus', () => {
          this.activeInput = input;
          const q = (input.value || '').trim();
          if (q.length >= 2) this.fetchAndRenderPredictive(q);
        });

        input.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.closePredictive();
        });
      });
    }

    /* ======================================================
       Predictive fetch
       - products
       - suggested queries
       - articles (blog posts)
    ====================================================== */
    async fetchAndRenderPredictive(query){
      try{
        if (this._predictiveAbort) this._predictiveAbort.abort();
        this._predictiveAbort = new AbortController();
        const signal = this._predictiveAbort.signal;

        const allLink = this.predictiveEl.querySelector('.ai-predictive__all-' + aiGenId);
        if (allLink){
          allLink.href = `/search?q=${encodeURIComponent(query)}`;
          allLink.textContent = `View all results for “${query}”`;
        }

        const cacheKey = query.toLowerCase();
        if (this._predictiveCache.has(cacheKey)){
          const cached = this._predictiveCache.get(cacheKey);
          this.renderPredictiveResults(cached, query);
          this.openPredictive();
          return;
        }

        const base = (window.Shopify?.routes?.root) ? window.Shopify.routes.root : '/';

        const url =
          `${base}search/suggest.json?q=${encodeURIComponent(query)}` +
          `&resources[type]=query,product,article,collection,page` +
          `&resources[limit]=10` +
          `&resources[limit_scope]=each` +
          `&resources[options][unavailable_products]=last`;

let res = await fetch(url, {
  headers: { 'Accept': 'application/json' },
  signal
});

let data = await res.json();

/* fallback search terms */
if (
  (!data?.resources?.results?.products ||
   data.resources.results.products.length === 0)
) {

  let fallbackQuery = query;

  fallbackQuery = fallbackQuery.replace(/\bdry malt ex\b/gi, 'dried malt extract');
  fallbackQuery = fallbackQuery.replace(/\bdry malt\b/gi, 'dried malt');
  fallbackQuery = fallbackQuery.replace(/\bdme\b/gi, 'dried malt extract');

  if (fallbackQuery !== query) {

    const fallbackUrl =
      `${base}search/suggest.json?q=${encodeURIComponent(fallbackQuery)}` +
      `&resources[type]=query,product,article,collection,page` +
      `&resources[limit]=10` +
      `&resources[limit_scope]=each` +
      `&resources[options][unavailable_products]=last`;

    res = await fetch(fallbackUrl, {
      headers: { 'Accept': 'application/json' },
      signal
    });

    data = await res.json();
  }
}

        if (!res.ok) throw new Error('Suggest request failed');


        this._predictiveCache.set(cacheKey, data);
        if (this._predictiveCache.size > 30){
          const firstKey = this._predictiveCache.keys().next().value;
          this._predictiveCache.delete(firstKey);
        }

        this.renderPredictiveResults(data, query);
        this.openPredictive();
      } catch(err){
        if (err && err.name === 'AbortError') return;
        this.closePredictive();
      }
    }

    /* ======================================================
       Predictive render
    ====================================================== */
renderPredictiveResults(data, query){
  const inner = this.predictiveEl.querySelector('.ai-predictive__inner-' + aiGenId);
  const results = data?.resources?.results || {};
  const isMobile = window.matchMedia('(max-width: 749px)').matches;

  const products = (results.products || []).slice(0, isMobile ? 4 : 10);
  const articles = (results.articles || []).slice(0, isMobile ? 2 : 5);
  const queries = (results.queries || []).slice(0, isMobile ? 3 : 5);
  const collections = (results.collections || []).slice(0, 5);
  const pages = (results.pages || []).slice(0, 5);

  if (!isMobile){
  this.renderDesktopMegaPredictive({
  inner,
  products,
  articles,
  queries,
  collections,
  pages,
  query
});

  if (products.length){
    this.hydratePrices(products);
    this.hydrateDesktopProductActions(products);
  }

  return;
}

  const blocks = [];

  const sectionHeader = (label) => `
    <div class="ai-predictive__section-${aiGenId}">${this.escapeHtml(label)}</div>
  `;

  const emptyThumb = `<div class="ai-predictive__thumb-${aiGenId}"></div>`;

  const row = ({
    href,
    title,
    thumbHtml,
    extraHtml = '',
    kind = 'compact',
    delay = 0
  }) => {
    const classes = [
      `ai-predictive__item-${aiGenId}`,
      kind === 'product' ? 'is-product' : '',
      kind === 'compact' ? 'is-compact' : '',
      kind === 'article' ? 'is-article' : ''
    ].filter(Boolean).join(' ');

    return `
      <a class="${classes}"
         href="${href}"
         role="option"
         style="animation-delay:${delay}ms">
        ${thumbHtml || emptyThumb}
        <div class="ai-predictive__meta-${aiGenId}">
          <div class="ai-predictive__title-${aiGenId}">${this.escapeHtml(title)}</div>
          ${extraHtml}
        </div>
      </a>
    `;
  };

  if (products.length){
    blocks.push(sectionHeader('Products'));

    blocks.push(
      products.map((p, i) => {
        const title = p.title || 'Product';
        const href = p.url || `/search?q=${encodeURIComponent(query)}`;
        const handle = p.handle || this.extractHandleFromUrl(href);

        const img =
          p.featured_image?.url ||
          p.featured_image ||
          p.image ||
          p?.images?.[0] ||
          '';

        const thumbHtml = img
  ? `<img class="ai-predictive__thumb-${aiGenId}" src="${img}" alt="${this.escapeAttr(title)}" loading="lazy">`
  : emptyThumb;

        const cached = handle ? this._priceCache.get(handle) : null;

        const compareSpan = (cached?.compareCents)
          ? `<span class="re-compare" data-compare>${this.formatMoney(cached.compareCents)}</span>`
          : `<span class="ai-predictive__compare-${aiGenId}" data-compare style="display:none;"></span>`;

        const priceSpan = (cached?.priceCents != null)
          ? `<span class="ai-predictive__current-${aiGenId}" data-price>${this.formatMoney(cached.priceCents)}</span>`
          : `<span class="re-regular" data-price>`;

        const priceStateClass = (cached?.priceCents != null) ? 'is-ready' : 'is-loading';

        const priceHtml = `
          <div class="ai-predictive__price-${aiGenId} ${priceStateClass}" data-ai-price-handle="${this.escapeAttr(handle)}">
            ${compareSpan}
            ${priceSpan}
          </div>
        `;

        return row({
          href,
          title,
          thumbHtml,
          extraHtml: priceHtml,
          kind: 'product',
          delay: i * 40
        });
      }).join('')
    );
  }

  if (articles.length){
    blocks.push(sectionHeader('Blog posts'));

    blocks.push(
      articles.map((article, i) => {
        const title = article.title || 'Article';
        const href = article.url || `/search?q=${encodeURIComponent(query)}`;

        const img =
          article.image?.url ||
          article.image ||
          article.featured_image?.url ||
          article.featured_image ||
          '';

        const thumbHtml = img
  ? `<img class="ai-predictive__thumb-${aiGenId}" src="${img}" alt="${this.escapeAttr(title)}" loading="lazy">`
  : emptyThumb;

        return row({
          href,
          title,
          thumbHtml,
          kind: 'article',
          delay: products.length * 40 + i * 35
        });
      }).join('')
    );
  }

  if (queries.length){
    blocks.push(sectionHeader('Suggested searches'));

    blocks.push(
      queries.map((qObj, i) => {
        const qText = qObj?.text || qObj?.query || qObj?.title || '';
        const href = `/search?q=${encodeURIComponent(qText || query)}`;

        return row({
          href,
          title: qText || query,
          thumbHtml: emptyThumb,
          kind: 'compact',
          delay: products.length * 40 + articles.length * 35 + i * 35
        });
      }).join('')
    );
  }

  if (!blocks.length){
    inner.innerHTML = `<div style="padding:12px 0; font-size:13px; opacity:.75;">No results found.</div>`;
    return;
  }

  inner.innerHTML = blocks.join('');

  if (products.length){
    this.hydratePrices(products);
    this.hydrateDesktopProductActions(products);
  }
}
renderDesktopMegaPredictive({ inner, products, articles, queries, collections, pages, query }){
  const searchIcon = `
    <svg class="ai-predictive-sidebar-icon-${aiGenId}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
    </svg>
  `;

  const productCards = products.length
    ? products.map((p) => {
        const title = p.title || 'Product';
        const href = p.url || `/search?q=${encodeURIComponent(query)}`;
        const handle = p.handle || this.extractHandleFromUrl(href);
        const img = p.featured_image?.url || p.featured_image || p.image || p?.images?.[0] || '';

        const cached = handle ? this._priceCache.get(handle) : null;

        const compareSpan = cached?.compareCents
          ? `<span class="re-compare" data-compare>${this.formatMoney(cached.compareCents)}</span>`
          : `<span class="re-compare" data-compare style="display:none;"></span>`;

        const priceSpan = cached?.priceCents != null
          ? `<span class="re-regular" data-price>${this.formatMoney(cached.priceCents)}</span>`
          : `<span class="re-regular" data-price></span>`;

        const priceStateClass = cached?.priceCents != null ? 'is-ready' : 'is-loading';

        return `
          <div class="ai-predictive-product-card-${aiGenId} re-card" role="option">
            <a class="ai-predictive-product-image-wrap-${aiGenId} re-card__media" href="${href}">
              ${img ? `<img class="ai-predictive-product-image-${aiGenId} re-img" src="${img}" alt="${this.escapeAttr(title)}" loading="lazy">` : ''}
            </a>

            <div class="re-card__body re-card__body--stack">
              <div class="re-title">
                <a href="${href}">${this.escapeHtml(title)}</a>
              </div>

              <div class="re-priceLine ai-predictive__price-${aiGenId} ${priceStateClass}" data-ai-price-handle="${this.escapeAttr(handle)}">
                ${compareSpan}
                ${priceSpan}
              </div>

              <div class="re-card__actions">
                <button
                  type="button"
                  class="re-btn re-btn--cart"
                  data-ai-predictive-add
                  data-ai-predictive-handle="${this.escapeAttr(handle)}"
                >
                  <span>Add To Basket</span>
                  <svg class="re-btn__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M1.5 6.5H13.5V15.5H1.5V6.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13.5 9H18L21 12V15.5H13.5V9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5 18A2 2 0 1 0 5 14A2 2 0 0 0 5 18Z" stroke="currentColor" stroke-width="2"/>
                    <path d="M17 18A2 2 0 1 0 17 14A2 2 0 0 0 17 18Z" stroke="currentColor" stroke-width="2"/>
                    <path d="M4 10H8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </button>
              </div>

              <div class="re-stockpill" data-ai-stock-handle="${this.escapeAttr(handle)}">
                <span class="re-stockpill__dot"></span>
                <span>Checking stock...</span>
              </div>
            </div>
          </div>
        `;
      }).join('')
    : `<div class="ai-predictive-mega-empty-${aiGenId}">No products found.</div>`;

  const suggestionLinks = queries.length
    ? queries.map((qObj) => {
        const qText = qObj?.text || qObj?.query || qObj?.title || query;
        return `
          <a class="ai-predictive-sidebar-link-${aiGenId}" href="/search?q=${encodeURIComponent(qText)}">
            ${searchIcon}
            <span>${this.escapeHtml(qText)}</span>
          </a>
        `;
      }).join('')
    : `
      <a class="ai-predictive-sidebar-link-${aiGenId}" href="/search?q=${encodeURIComponent(query)}">
        ${searchIcon}
        <span>${this.escapeHtml(query)}</span>
      </a>
    `;

  inner.innerHTML = `
    <div class="ai-predictive-mega-${aiGenId}">
<div class="ai-predictive-mega-main-${aiGenId}">
  <h3 class="ai-predictive-mega-title-${aiGenId}">Products</h3>

  <div class="ai-predictive-products-grid-${aiGenId}">
    ${productCards}
  </div>

  <div class="ai-predictive-desktop-cta-${aiGenId}">
    <a
      class="ai-predictive-desktop-btn-${aiGenId}"
      href="/search?q=${encodeURIComponent(query)}"
    >
      See All Results
    </a>
  </div>
</div>

      <aside class="ai-predictive-mega-sidebar-${aiGenId}">
        <div class="ai-predictive-sidebar-section-${aiGenId}">
          <h3 class="ai-predictive-sidebar-title-${aiGenId}">Suggestions</h3>
          ${suggestionLinks}
        </div>
        ${collections.length ? `
  <div class="ai-predictive-sidebar-section-${aiGenId}">
    <h3 class="ai-predictive-sidebar-title-${aiGenId}">Collections</h3>
    ${collections.map((c) => `
      <a class="ai-predictive-sidebar-link-${aiGenId}" href="${c.url}">
        ${searchIcon}
        <span>${this.escapeHtml(c.title)}</span>
      </a>
    `).join('')}
  </div>
` : ''}

${articles.length ? `
  <div class="ai-predictive-sidebar-section-${aiGenId}">
    <h3 class="ai-predictive-sidebar-title-${aiGenId}">Blog posts</h3>
    ${articles.map((a) => `
      <a class="ai-predictive-sidebar-link-${aiGenId}" href="${a.url}">
        ${searchIcon}
        <span>${this.escapeHtml(a.title)}</span>
      </a>
    `).join('')}
  </div>
` : ''}

${pages.length ? `
  <div class="ai-predictive-sidebar-section-${aiGenId}">
    <h3 class="ai-predictive-sidebar-title-${aiGenId}">Pages</h3>
    ${pages.map((p) => `
      <a class="ai-predictive-sidebar-link-${aiGenId}" href="${p.url}">
        ${searchIcon}
        <span>${this.escapeHtml(p.title)}</span>
      </a>
    `).join('')}
  </div>
` : ''}
      </aside>
    </div>
  `;
}
async hydrateDesktopProductActions(products){
  const base = (window.Shopify?.routes?.root) || '/';

  const handles = products
    .map((p) => p.handle || this.extractHandleFromUrl(p.url))
    .filter(Boolean);

  const uniqueHandles = Array.from(new Set(handles)).slice(0, 10);

  await Promise.allSettled(uniqueHandles.map(async (handle) => {
    const productRes = await fetch(`${base}products/${handle}.js`);
    const stockRes = await fetch(`${base}products/${handle}?view=stock-json&_=${Date.now()}`);

    if (!productRes.ok) throw new Error('Product fetch failed');

    const product = await productRes.json();
    const stockData = stockRes.ok ? await stockRes.json() : {};

    const variant =
      product.variants?.find((v) => v.available) ||
      product.variants?.[0];

    const stockEl = this.predictiveEl.querySelector(
      `[data-ai-stock-handle="${window.CSS.escape(handle)}"]`
    );

    const btn = this.predictiveEl.querySelector(
      `[data-ai-predictive-handle="${window.CSS.escape(handle)}"]`
    );

    const isAvailable = !!(product.available && variant && variant.available);
    const stockQty = Number(stockData.stockQty || 0);
    const variantId = variant?.id;

    const isBackorderTagged = product.tags && product.tags.includes('backorder');

if (stockEl) {
  if (isAvailable) {
    if (isBackorderTagged) {
      stockEl.className = 're-stockpill is-backorder';
      stockEl.innerHTML = `<span class="re-stockpill__dot"></span><span>Back Order</span>`;
    } else if (stockQty > 2) {
      stockEl.className = 're-stockpill';
      stockEl.innerHTML = `<span class="re-stockpill__dot"></span><span>3+ in stock</span>`;
    } else if (stockQty === 1 || stockQty === 2) {
      stockEl.className = 're-stockpill is-low';
      stockEl.innerHTML = `<span class="re-stockpill__dot"></span><span>${stockQty} in stock</span>`;
    } else {
      stockEl.className = 're-stockpill is-backorder';
      stockEl.innerHTML = `<span class="re-stockpill__dot"></span><span>Back Order</span>`;
    }
  } else {
    stockEl.className = 're-stockpill is-out';
    stockEl.innerHTML = `<span class="re-stockpill__dot"></span><span>Out of stock</span>`;
  }
} 

    if (btn) {
      if (isAvailable && variantId) {
        btn.disabled = false;
        btn.className = 're-btn re-btn--cart';
        btn.dataset.variantId = variantId;
        btn.dataset.aiPredictiveAdd = 'true';
        btn.innerHTML = `
  <span>Add To Basket</span>
  <svg class="re-btn__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M1.5 6.5H13.5V15.5H1.5V6.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.5 9H18L21 12V15.5H13.5V9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 18A2 2 0 1 0 5 14A2 2 0 0 0 5 18Z" stroke="currentColor" stroke-width="2"/>
    <path d="M17 18A2 2 0 1 0 17 14A2 2 0 0 0 17 18Z" stroke="currentColor" stroke-width="2"/>
    <path d="M4 10H8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  </svg>
`;
      } else {
        btn.disabled = false;
        btn.className = 're-btn re-btn--view';
        btn.innerHTML = '<span>View Details</span>';
        btn.dataset.aiPredictiveAdd = 'false';
        btn.dataset.productUrl = product.url || `/products/${handle}`;
      }
    }
  }));
}
    /* ======================================================
       Product price hydration
    ====================================================== */
    async hydratePrices(products){
  const token = ++this._priceToken;
  const base = (window.Shopify?.routes?.root) || '/';

  const handles = products
    .map((p) => p.handle || this.extractHandleFromUrl(p.url))
    .filter(Boolean);

  const uniqueHandles = Array.from(new Set(handles)).slice(0, 10);

  const jobs = uniqueHandles.map(async (handle) => {
    try{
      const res = await fetch(`${base}products/${handle}.js`, {
        headers: { 'Accept': 'application/json' }
      });

      if (!res.ok) throw new Error('bad response');

      const prod = await res.json();

      const priceCents = Number(prod.price_min || prod.price || 0);
      const compareCents = Number(prod.compare_at_price_min || prod.compare_at_price || 0);

      const payload = {
        priceCents,
        compareCents: compareCents > priceCents ? compareCents : null
      };

      this._priceCache.set(handle, payload);
      this.paintPrice(handle, payload, token);
    } catch(e){
      this.paintPrice(handle, null, token);
    }
  });

  await Promise.allSettled(jobs);
}

    paintPrice(handle, payload, token){
      if (token !== this._priceToken) return;
      if (!this.predictiveEl || !handle) return;

      const wrap = this.predictiveEl.querySelector(
        `[data-ai-price-handle="${window.CSS.escape(handle)}"]`
      );

      if (!wrap) return;

      const priceEl = wrap.querySelector('[data-price]');
      const compareEl = wrap.querySelector('[data-compare]');

      if (!payload || payload.priceCents == null){
        if (priceEl) priceEl.textContent = '';
        if (compareEl) compareEl.style.display = 'none';
        wrap.classList.remove('is-loading');
        wrap.classList.add('is-ready');
        return;
      }

      if (priceEl) priceEl.textContent = this.formatMoney(payload.priceCents);

      if (compareEl && payload.compareCents){
        compareEl.textContent = this.formatMoney(payload.compareCents);
        compareEl.style.display = '';
      } else if (compareEl){
        compareEl.style.display = 'none';
      }

      wrap.classList.remove('is-loading');
      wrap.classList.add('is-ready');
    }

    /* ======================================================
       Predictive dropdown open / close / position
    ====================================================== */
openPredictive(){
  if (!this.predictiveEl || !this.activeInput) return;

  this.positionPredictive();
  this.predictiveEl.classList.add('is-open');

  if (this.predictiveBackdrop){
    this.predictiveBackdrop.classList.add('is-open');
  }

  document.body.style.overflow = 'hidden';
}

closePredictive(){
  if (!this.predictiveEl) return;

  this.predictiveEl.classList.remove('is-open');
  this.predictiveEl.style.display = '';

  if (this.predictiveBackdrop){
    this.predictiveBackdrop.classList.remove('is-open');
  }

  document.body.style.overflow = '';
}

    positionPredictive(){
      if (!this.predictiveEl || !this.activeInput) return;

      const rect = this.activeInput.getBoundingClientRect();
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      if (isMobile && this.searchMobileContainer && this.searchMobileContainer.classList.contains('active')){
        const top = Math.round(rect.bottom);
        this.predictiveEl.style.left = '0px';
        this.predictiveEl.style.top = top + 'px';
        this.predictiveEl.style.width = '100vw';
        return;
      }

const gap = 0;
const headerRect = this.getBoundingClientRect();
const top = headerRect.bottom + gap;

this.predictiveEl.style.left = '0px';
this.predictiveEl.style.top = Math.round(top) + 'px';
this.predictiveEl.style.width = '100vw';
    }

    /* ======================================================
       Helpers
    ====================================================== */
    toCents(value){
      if (value == null) return null;

      if (typeof value === 'string'){
        const v = value.trim();
        if (v === '') return null;

        if (v.includes('.')) {
          const f = parseFloat(v);
          return Number.isFinite(f) ? Math.round(f * 100) : null;
        }

        const n = Number(v);
        return Number.isFinite(n) ? Math.round(n) : null;
      }

      const n = Number(value);
      if (!Number.isFinite(n)) return null;

      if (Math.floor(n) !== n) return Math.round(n * 100);

      return Math.round(n);
    }

    formatMoney(cents){
      const n = Number(cents);
      if (!Number.isFinite(n)) return '';

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.Shopify.money_format){
        return window.Shopify.formatMoney(n, window.Shopify.money_format);
      }

      return '£' + (n / 100).toFixed(2);
    }

    extractHandleFromUrl(url){
      if (!url) return '';
      const m = String(url).match(/\/products\/([^\/\?#]+)/);
      return m && m[1] ? m[1] : '';
    }

    escapeHtml(str){
      return String(str).replace(/[&<>"']/g, (m) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[m]));
    }

    escapeAttr(str){
      return String(str || '').replace(/"/g, '&quot;');
    }
  }

  if (!customElements.get('hopshop-header')) {
    customElements.define('hopshop-header', HeaderBlock);
  }
  window.addEventListener('scroll', function(){
  if (window.innerWidth < 750) return;

  if (window.scrollY > 80){
    document.body.classList.add('is-scrolled-desktop');
  } else {
    document.body.classList.remove('is-scrolled-desktop');
  }
}, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_b674cb9"] && !Shopify.designMode) return;
  try {
    (function(){
  const root = document.querySelector('[data-premium-flyout]');
  if(!root || root.dataset.navigationInitialized === 'true') return;
  root.dataset.navigationInitialized = 'true';

  const topItems = Array.from(root.querySelectorAll('.top-item'));
  let closeTimer = null;

  const closeAll = () => {
    topItems.forEach(i => i.classList.remove('open'));
    root.querySelectorAll('.dd-item').forEach(i => i.classList.remove('flyopen'));
    root.querySelectorAll('.top-btn[aria-expanded]').forEach(b => b.setAttribute('aria-expanded','false'));
    root.querySelectorAll('.dd-btn[aria-expanded]').forEach(b => b.setAttribute('aria-expanded','false'));
  };

  const scheduleClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeAll, 160);
  };

  const cancelClose = () => clearTimeout(closeTimer);

  topItems.forEach(item => {
    const topBtn = item.querySelector('.top-btn');

    item.addEventListener('mouseenter', () => {
      cancelClose();
      topItems.forEach(sib => { if(sib !== item) sib.classList.remove('open'); });
      item.classList.add('open');
      if(topBtn) topBtn.setAttribute('aria-expanded','true');
    });

    item.addEventListener('mouseleave', scheduleClose);

    item.addEventListener('focusin', () => {
      cancelClose();
      topItems.forEach(sib => { if(sib !== item) sib.classList.remove('open'); });
      item.classList.add('open');
      if(topBtn) topBtn.setAttribute('aria-expanded','true');
    });

    item.addEventListener('focusout', (e) => {
      if(!item.contains(e.relatedTarget)) scheduleClose();
    });

    item.querySelectorAll('.dd-item').forEach(ddItem => {
      const ddBtn = ddItem.querySelector('.dd-btn');

      ddItem.addEventListener('mouseenter', () => {
        cancelClose();
        item.querySelectorAll('.dd-item').forEach(s => s.classList.remove('flyopen'));
        ddItem.classList.add('flyopen');
        if(ddBtn) ddBtn.setAttribute('aria-expanded','true');
      });

      ddItem.addEventListener('focusin', () => {
        cancelClose();
        item.querySelectorAll('.dd-item').forEach(s => s.classList.remove('flyopen'));
        ddItem.classList.add('flyopen');
        if(ddBtn) ddBtn.setAttribute('aria-expanded','true');
      });
    });
  });

  document.addEventListener('keydown', (e) => {
    if(e.key === 'Escape') closeAll();
  });

  document.addEventListener('click', (e) => {
    if(!root.contains(e.target)) closeAll();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
